<div class="container-fluid">
    <div class="row">

      <div class="card shadow-sm p-0">
        <div class="card-header">
          <h3 class="card-title">{{ lawId ? 'Update Law' : ' Create Law' }} </h3>
        </div>
        <div class="card-body">
          <laws-form
            [law]="law"
            (onSavedData)="onLawFormSavedData($event)"
          />
        </div>
      </div>
    </div>
    
  </div>